// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from "@/components/auth/AuthProvider"
import AppRoutes from "./routes"
import { ThemeProvider } from "./layout/ThemeProvider.tsx"
import { Toaster } from "@/components/ui/sonner"
import { initializeGA } from "@/lib/analytics"
import { usePageTracking } from "@/hooks/usePageTracking"

// Load the GA4 script and initialise the dataLayer on app startup.
initializeGA()

/**
 * Wrapper component that enables route-change page view tracking.
 * Must live inside <BrowserRouter> to access the current location.
 */
function AnalyticsProvider({ children }: { children: React.ReactNode }): React.JSX.Element {
  usePageTracking()
  return <>{children}</>
}

export default function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <BrowserRouter>
        <AnalyticsProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </AnalyticsProvider>
      </BrowserRouter>
      <Toaster />
    </ThemeProvider>
  )
}
